import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Learn18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.4678 2.42159C8.8049 2.26295 9.1952 2.26295 9.53229 2.42159L16.858 5.86899C17.6589 6.24588 17.7896 7.26074 17.25 7.84579V12C17.25 12.4142 16.9142 12.75 16.5 12.75C16.0858 12.75 15.75 12.4142 15.75 12V8.65246L14.75 9.12305V13C14.75 13.7155 13.6637 14.3568 13.2056 14.6387C12.2859 15.2047 10.9012 15.75 9 15.75C7.09877 15.75 5.71408 15.2047 4.79443 14.6387C4.34338 14.3612 3.25 13.7214 3.25 13V9.12301L1.14207 8.13104C0.185061 7.68068 0.18507 6.31934 1.14207 5.86899L8.4678 2.42159ZM9.00005 3.82891L2.26145 7.00002L9.00005 10.1711L15.7386 7.00002L9.00005 3.82891ZM9.53229 11.5784L13.25 9.82893V12.714C12.8219 13.1451 11.5086 14.25 9 14.25C6.49135 14.25 5.17813 13.1451 4.75 12.714V9.82889L8.4678 11.5784C8.8049 11.7371 9.19519 11.7371 9.53229 11.5784Z'
      fill='currentColor'
    />
  </Svg>
);

Learn18.displayName = 'Learn18';
export default Learn18;
